<template>
    <div class="w-1200" style="padding-bottom: 60px;">
        <div class="font-24  font-500 mt-8">Literature</div>
        <div class="mt-8" style="width: 1200px;height: 10px;background: #F7F9FA;"></div>
        <div>
            <div class="item" v-for="item in news.data" :key="item.id" @click="$router.push({
                path: 'literature-detail',
                query:{
                    id:item.id
                }
            })">
                <div class="font-32 font-600">{{item.title}}</div>
                <div class="mt-3 ellipsis-2" v-html="item.content"></div>
                <div class="mt-2">{{item.c_time}}</div>
            </div>
        </div>
        <div class="flex flex-j-c">
            <el-pagination
                    class="mt-50"
                    :page-size="5"
                    background
                    layout="prev, pager, next"
                    @current-change="getNews"
                    :total="news.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'literature',
        data() {
            return {
                news: {}
            }
        },
        mounted() {
            this.getNews()
        },
        methods: {
            async getNews(page = 1) {
                this.news = await this.$api.getNews({page: page})
            },

        },

    }
</script>
<style scoped lang="scss">
    .item {
        position: relative;
        padding: 40px 0;

        &::after {
            position: absolute;
            content: '';
            width: 1200px;
            height: 1px;
            background: #DDDDDD;
            left: 0;
            bottom: 0;
        }

        &:last-child::after {
            height: 0;
        }

    }
</style>
